<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Bt2Hmw/tc-custom/9781526786685.jpg?1704717799571" alt="This image is the cover for the book Wellington's Infantry"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wellington's Infantry
      </h1>
      <p class="bookDescription body article font2">
        <b>This illustrated history presents a detailed overview of the British infantry’s organization, uniforms, and equipment during the Napoleonic Period.</b><br/><br/>The years from 1800 to 1815 were one of the most glorious periods for the British Army—and the infantry was its backbone. Lavishly illustrated with color artwork, this book examines how the foot regiments evolved to absorb the lessons of defeat in America, transforming them into the efficient and dependable bedrock of victory in the Napoleonic Wars. <br/><br/>Historian Gabriel Esposito details the uniforms, equipment, and weapons of the infantry, along with their organization and tactics. Chapters are devoted to the Guards, the line regiments of foot, the Light Infantry and Rifles, as well as Highland and Lowland Scots regiments.<br/><br/>Esposito considers not only those units serving with Wellington in the Peninsular War and the Waterloo Campaign, but all British infantry units, including those in Canada, the West Indies, India and elsewhere—including the home defense Fencibles. Foreign units serving with the British army, most notably the King's German Legion, are also included.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gabriele Esposito
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f4ec2ce